module.exports = __webpack_public_path__ + "static/media/Sec-4_Banner_VN_Mobile.9d2a5217.png";